<template>
  <div>
    <div class="manage-answers-page">
      <div class="manage-answers-page__header -mt-5 u-margin-bottom-small">
        <div class="row">
          <div class="w-50">
            <div class="form-input">
              <label for="select_question_type" class="control-label">{{ $t('Choose Question Type') }}</label>
              <multiselect
                v-model="selectedQuestionType"
                :options="questionTypes"
                id="select_question_type"
                :loading="loading"
                track-by="id"
                label="name"
                :multiple="false"
                :close-on-select="true"
                :show-labels="false"
              >
              </multiselect>
            </div>
          </div>
        </div>
      </div>
      <div class="manage-answers-page__body">
        <div class="row position-relative">
          <div class="w-50">
            <div class="form-input">
              <label for="choose_company" class="control-label">{{ $t('Choose Organization') }}</label>
              <multiselect
                v-model="company"
                :options="companies"
                id="choose_company"
                :loading="loading"
                track-by="company_id"
                label="name"
                :multiple="false"
                @select="setCompany($event)"
                :close-on-select="true"
                :show-labels="false"
              >
              </multiselect>
            </div>
          </div>
          <div v-if="selectedQuestionType && company">
            <router-link
              :to="{
                name: 'Company Questionnaire',
                query: {
                  company: company,
                  selectedQuestionType: selectedQuestionType,
                },
              }"
            >
              <p-button outline type="success" class="nextBtn"> {{ $t('Next') }} &rarr; </p-button>
            </router-link>
          </div>
        </div>
        <div class="row">
          <card class="card w-full" title="Certificates">
            <div v-if="company && canManageQuestions()" class="card__right-button">
              <div class="position-relative">
                <button
                  class="btn btn-just-icon btn-outline-warning mr-3 tooltipBtn"
                  @click="openNewCertificateModal = true"
                >
                  <i class="fas fa-plus"></i>
                </button>
                <div class="tooltipCustom tooltipCustom--bottom">Assign new Certificate</div>
              </div>
            </div>
            <div>
              <div v-if="company && company_certificates && !loadingCertificates" class="certificates">
                <div class="row" v-if="company_certificates.length > 0">
                  <div
                    v-for="(company_certificate, index) in company_certificates"
                    v-bind:key="index"
                    class="certificate certificate--show mt-2"
                  >
                    <img class="certificate__img" :src="company_certificate.certificate.img_url" alt="" />
                    <div class="certificate__text-block">
                      <p class="certificate__name">{{ company_certificate.certificate.name }}</p>
                      <p class="certificate__achieved">Achieved at {{ company_certificate.achieved_at }}</p>
                    </div>
                  </div>
                </div>
                <div v-else>This company does not have certificates</div>
              </div>
              <div v-if="loadingCertificates" class="loading certificate__loading">
                <MoonLoader />
              </div>
              <div v-if="!loadingCertificates && !company">
                <p>Select Organization to see its Certificates</p>
              </div>
            </div>
          </card>
        </div>
      </div>
      <div class="manage-answers-page__footer"></div>
    </div>
    <ModalTemplate
      component-name="AssignCertificateModal"
      :data="{
        header: 'Assign new Certificate',
        company: company,
      }"
      :clicked="openNewCertificateModal"
      @update:field="openNewCertificateModal = false"
      @submit="addCertificate($event)"
    >
    </ModalTemplate>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import CompanyController from '../../controllers/Company/CompanyController';
import CompanyCertificatesController from '../../controllers/CompanyCertificates/CompanyCertificatesController';
import axiosAuth from '../../axiosMain';
import MoonLoader from '../../components/svg/SvgLoaderMoon';
import QuestionTypeController from '../../controllers/QuestionType/QuestionTypeController';
import ModalTemplate from '../../components/modals/ModalTemplate';
import checkIfCanSeeManageQuestions from '@/router/scopes/manage_questions/CheckIfCanSeeManageQuestions';
import checkIfCanSeeCertificates from '@/router/scopes/certificates/CheckIfCanSeeCertificates';

export default {
  name: 'ManageAnswers',
  components: {
    ModalTemplate,
    MoonLoader,
    Multiselect,
  },
  data() {
    return {
      company: null,
      companies: [],
      loading: true,
      loadingCertificates: false,
      company_certificates: null,
      selectedQuestionType: null,
      questionTypes: [],
      openNewCertificateModal: false,
    };
  },
  async beforeMount() {
    this.setLoading();
    await this.getCompanies();
    await this.getQuestionTypes();
    this.resetLoading();
  },
  methods: {
    setCompany(company) {
      this.company = company;
      this.setCertificates(company);
    },
    async setCertificates(company) {
      this.loadingCertificates = true;
      this.company_certificates = await CompanyCertificatesController.show(company.company_id);
      this.loadingCertificates = false;
    },
    async getCompanies() {
      let companies = await CompanyController.index();
      Object(companies).forEach((company) => {
        this.companies.push(company.data);
      });
    },
    async getQuestionTypes() {
      this.questionTypes = await QuestionTypeController.index();
      this.questionTypes = this.questionTypes.filter(function (questionType) {
        return questionType.name !== 'Initiative';
      });
      this.questionTypes = this.questionTypes.sort();
    },
    setLoading() {
      this.loading = true;
    },
    resetLoading() {
      this.loading = false;
    },
    async addCertificate(certificate) {
      let newCertificate = await CompanyCertificatesController.store({
        company_id: this.company.company_id,
        certification_id: certificate.id,
        achieved_at: '1997-06-13',
      });

      this.company_certificates.push(newCertificate);
    },
    canManageQuestions() {
      return checkIfCanSeeManageQuestions() && checkIfCanSeeCertificates();
    },
  },
};
</script>

<style scoped></style>
<style src="../../../node_modules/vue-multiselect/dist/vue-multiselect.min.css"></style>
